import { Form, Button, FlexboxGrid, ButtonToolbar, Message, useToaster, RadioGroup, Radio} from 'rsuite';
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import { getById, recoveryPassword } from 'services/microsoftGraphApi';
import { RequestVM } from 'models/requestVM';
import CryptoJS from 'crypto-js';
import ClipLoader from 'react-spinners/ClipLoader';

function Opciones(props) {

  const [userName, setUserName] = useState();
  const [mail, setMail] = useState();
  const [mailHidden, setMailHidden] = useState();
  const [mobilePhone, setMobilePhone] = useState();
  const [mobilePhoneHidden, setMobilePhoneHidden] = useState();
  const [value, setValue] = useState();
  const [loadingInProgress, setLoading] = useState(false);
  const [isDisabledbutton, setDisibilityButton] = useState(true);

  const toaster = useToaster();

  const history = useHistory();

  const handleChange = (val) => {
    setValue(val);
    setDisibilityButton(false);
  };

  const readQueryParams = async () => {
    if (props.history != undefined)
    {
      const respuesta = props.history.location.pathname.replace('/opciones/','');    
      // Decrypt
      var bytes = CryptoJS.AES.decrypt(respuesta, 'my-secret-key@123');
      var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  
      if (decryptedData != null && decryptedData != undefined)
      {
        callMicrosoftGraphAPI(decryptedData);
      }
      else {
        toaster.push(
          <Message showIcon type="warning" header="Atención" duration={4000}>
            Debe ingresar la cuenta usuario colaborador.
          </Message>, { placement: 'topEnd' });
  
          goBack();
      }
    }
  };

  useEffect(() => {
    readQueryParams();
  });

  const callMicrosoftGraphAPI = async (id) => {
    const respuesta = await getById(id);

    if (respuesta.success)
    {
      let email = respuesta.data.mail;
      let emailHide = email.split("@")[0].length - 1;//<-- number of characters to hide
      var r = new RegExp(".{"+emailHide+"}@", "g");
      let emailHidden = email.replace(r, "***@" );

      let mobilePhone = respuesta.data.mobilePhone;      
      let mobilePhoneHidden = mobilePhone?.replace(/\d(?=.*\d{4})/g, "*");

      setUserName(respuesta.data.userPrincipalName);
      setMail(email);
      setMailHidden(emailHidden);
      setMobilePhone(mobilePhone);
      setMobilePhoneHidden(mobilePhoneHidden);
    }
    else {
      toaster.push(
        <Message showIcon type="warning" header="Atención" duration={4000}>
          No se encontró información para la cuenta usuario colaborador ingresada.
        </Message>, { placement: 'topEnd' });

      goBack();
    }
  };
  
  const callMicrosoftGraphAPI2 = async () => {
    if (value != null)
    {
      if (mail == null || mail == '') 
      {
        toaster.push(
          <Message showIcon type="warning" header="Atención" duration={4000}>
            Debe configurar el correo electrónico alternativo antes de continuar
          </Message>, { placement: 'topEnd' });
      }
      // else if (mobilePhone == null || mobilePhone == '') 
      // {
      //   toaster.push(
      //     <Message showIcon type="warning" header="Atención" duration={4000}>
      //       Debe configurar el N° móvil antes de continuar
      //     </Message>, { placement: 'topEnd' });
      // }      
      else
      {
        if (value === "B")
        {
          toaster.push(
            <Message showIcon type="warning" header="Atención" duration={4000}>
              El método de recuperación seleccionado aún no esta disponible para su utilización.
            </Message>, { placement: 'topEnd' });
        }
        else
        {
          setLoading(true);

          let model = new RequestVM(userName, "", "", value === "B" ? true: false, mobilePhone, mail);
    
          const respuesta = await recoveryPassword(model);
    
          if (respuesta.success) {
            setLoading(false);
    
            toaster.push(
              <Message showIcon type="success" header="Atención" duration={4000}>
                  Se ha recuperado correctamente la contraseña y enviado al método de recuperación seleccionado.
              </Message>, { placement: 'topEnd' });
              
            goBack();
          }
          else {
            setLoading(false);
    
            toaster.push(
              <Message showIcon type="error" header="Atención" duration={4000}>
                No se ha podido recuperar la contraseña para la cuenta usuario colaborador ingresada.
              </Message>, { placement: 'topEnd' });        
          }
        }
      }
    }
    else 
    {
      toaster.push(
        <Message showIcon type="warning" header="Atención" duration={4000}>
          Debe seleccionar un método de recuperación antes de continuar.
        </Message>, { placement: 'topEnd' });
    }
  };   

  const goBack = (() => {
    let path = '/recuperar'; 
    history.push(path);
  });
         
  const renderOpciones = (
    <Form layout='vertical'>              
      <RadioGroup name="radioList">
        <p>Opciones de Recuperación de Contraseña</p>
        <Radio value="A" onChange={handleChange}>Correo Electrónico Alternativo: { mailHidden }</Radio>                
        <Radio value="B" onChange={handleChange}>SMS a N° Móvil: { mobilePhoneHidden }</Radio>    
      </RadioGroup>
      <ButtonToolbar style={{ marginTop: '5%', textAlign: 'right' }}>  
        <Button appearance="primary" color='blue' type="submit" onClick={callMicrosoftGraphAPI2} disabled={isDisabledbutton}>
          Confirmar
        </Button>
        <Button appearance="subtle" color='green' type="submit" onClick={goBack}>
          Volver
        </Button>
      </ButtonToolbar>               
    </Form>
  );

  return (
    <FlexboxGrid justify="center" align="middle" style={{ marginTop: '5%', backgroundColor: '#FFF' }}>
      {loadingInProgress ? (<ClipLoader color={'#000000'} size={150} />) : (renderOpciones)}      
    </FlexboxGrid>
  );
}

const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);

root.render(<Opciones/>);

export default Opciones;